import { useCallback, useState } from 'react';
import { Stack } from '@mui/material';

import { QuestionnaireSectionLabel, QUESTIONNAIRE_PAGE_BOX_SX } from '../../../../common';
import {
  NotAttendingSchoolCheckbox,
  NotAttendingSchoolConfirmDialog,
  useFormReadOnly,
} from '../../../../../common';
import { EducationInfoSection } from './components';
import { useIntakeNotAttendingSchool } from './hooks';
import { FORTA_BLUE } from '../../../../../../utils/colors';

export default function EducationForm() {
  const { notAttendingSchool, hasEducationInfo, setNotAttendingSchool } =
    useIntakeNotAttendingSchool();
  const readOnly = useFormReadOnly();
  const [confirmNotAttendingOpen, setConfirmNotAttendingOpen] = useState(false);

  const handleToggleNotAttending = useCallback(
    (checked: boolean) => {
      if (!checked) {
        void setNotAttendingSchool(false);
        return;
      }
      setConfirmNotAttendingOpen(true);
    },
    [setNotAttendingSchool],
  );

  const handleConfirmNotAttending = useCallback(() => {
    setConfirmNotAttendingOpen(false);
    void setNotAttendingSchool(true);
  }, [setNotAttendingSchool]);

  const handleCloseConfirm = useCallback(() => setConfirmNotAttendingOpen(false), []);

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        Education
      </QuestionnaireSectionLabel>
      <Stack gap={2} textAlign="left" sx={QUESTIONNAIRE_PAGE_BOX_SX}>
        <NotAttendingSchoolCheckbox
          checked={notAttendingSchool}
          disabled={readOnly}
          onChange={handleToggleNotAttending}
        />

        {notAttendingSchool ? null : <EducationInfoSection />}

        <NotAttendingSchoolConfirmDialog
          open={confirmNotAttendingOpen}
          hasEducationInfo={hasEducationInfo}
          onClose={handleCloseConfirm}
          onConfirm={handleConfirmNotAttending}
        />
      </Stack>
    </>
  );
}
